import React from 'react';

const SupplierInfo: React.FC = () => {
  const getCurrentSupplierName = () => {
    const supplierName = localStorage.getItem('excel_supplier_name');
    return supplierName || 'No Supplier Selected';
  };

  const getSupplierMasterData = () => {
    const supplierName = getCurrentSupplierName();
    if (supplierName === 'No Supplier Selected') {
      return 'No Supplier Selected';
    }
    
    // Add spaces before uppercase letters that follow lowercase letters
    const formattedName = supplierName.replace(/([a-z])([A-Z])/g, '$1 $2');
    
    return `${formattedName} Master Data`;
  };

  return (
    <div className="supplier-info">
      <span className="supplier-master-data">{getSupplierMasterData()}</span>
    </div>
  );
};

export default SupplierInfo;
